import {
  SPACING_LARGE,
  SPACING_MED,
  SPACING_SMALL,
  SPACING_XLARGE,
  SPACING_XSMALL,
  SPACING_XXLARGE,
  SPACING_XXSMALL,
} from '../../consts';

export type Spacing = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'none';

export function mapToSpacing(spacing?: Spacing): string | undefined {
  switch (spacing) {
    case 'xxs':
      return `${SPACING_XXSMALL}px`;
    case 'xs':
      return `${SPACING_XSMALL}px`;
    case 'sm':
      return `${SPACING_SMALL}px`;
    case 'md':
      return `${SPACING_MED}px`;
    case 'lg':
      return `${SPACING_LARGE}px`;
    case 'xl':
      return `${SPACING_XLARGE}px`;
    case 'xxl':
      return `${SPACING_XXLARGE}px`;
    case 'none':
      return '0px';
    default:
      return undefined;
  }
}
